import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';

const ThumbnailGrid = ({ pages }) => {
  const { t } = useTranslation();
  
  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-elevation-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground flex items-center gap-2">
          <Icon name="Images" size={20} className="text-accent" />
          {t('pdfUpload.thumbnails.title')}
        </h3>
        <span className="text-sm text-muted-foreground">
          {pages?.length} {pages?.length === 1 ? t('pdfUpload.thumbnails.page') : t('pdfUpload.thumbnails.pages')}
        </span>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
        {pages?.map((page, index) => (
          <div
            key={index}
            className="group relative aspect-[3/4] bg-muted rounded-lg overflow-hidden border border-border hover:border-accent transition-all duration-250 hover:shadow-elevation-md"
          >
            <img
              src={page?.thumbnailUrl || page?.imageUrl}
              alt={t('pdfUpload.thumbnails.pageNumber', { number: page?.pageNumber })}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-250" />
            <div className="absolute bottom-0 left-0 right-0 p-2 text-center opacity-0 group-hover:opacity-100 transition-opacity duration-250">
              <span className="text-xs font-semibold text-white">
                {t('pdfUpload.thumbnails.pageNumber', { number: page?.pageNumber })}
              </span>
            </div>
            <div className="absolute top-2 right-2">
              <div className="w-6 h-6 rounded-full bg-success flex items-center justify-center">
                <Icon name="Check" size={12} className="text-success-foreground" />
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-4 p-4 bg-muted/50 rounded-lg">
        <div className="flex items-start gap-2 text-sm text-muted-foreground">
          <Icon name="Info" size={16} className="mt-0.5" />
          <p>
            {t('pdfUpload.thumbnails.successMessage')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ThumbnailGrid;